import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { Flex } from 'antd';
import { Controller, useForm } from 'react-hook-form';
import { TextInputComponent } from 'baseComponents/TextInputComponent';

export type UserFormValues = {
  apiKey: string;
};

type AdminUserFormProps = {
  onSubmit: (data: UserFormValues) => void;
  onCancel?: () => void;
  defaultValues?: Partial<UserFormValues>;
  submitButtonLabel?: string;
  mode?: 'create' | 'edit';
};

const initialState = {
  apiKey: '',
};

export const AdminApiConfigForm = ({
  onCancel,
  onSubmit,
  defaultValues,
  submitButtonLabel = 'Submit',
  mode = 'create',
}: AdminUserFormProps) => {
  const { handleSubmit, control } = useForm<UserFormValues>({
    mode: 'onSubmit',
    defaultValues: {
      ...initialState,
      ...defaultValues,
    },
    context: { mode },
  });

  const handleSubmitCallback = (data: any) => {
    onSubmit(data);
  };

  return (
    <form
      style={{ flex: 1, flexBasis: '100%' }}
      onSubmit={handleSubmit(handleSubmitCallback)}
    >
      <Flex vertical gap={16} style={{ padding: 2 }}>
        <Controller
          name='apiKey'
          control={control}
          render={({ field, fieldState }) => (
            <TextInputComponent label='Braze api key' {...field} />
          )}
        />
      </Flex>

      <Flex gap={8} style={{ maxWidth: 648, marginTop: 10 }}>
        <ButtonComponent
          label={submitButtonLabel}
          appereance='primary'
          size='middle'
          fullWidth
          htmlType='submit'
          style={{ maxWidth: 125 }}
        />
      </Flex>
    </form>
  );
};
